import i18next from 'i18next'
import { Translatable } from '../common/types/translatable'

export const getDetectedLanguage = () => i18next.language as keyof Translatable
